import { useState } from "react";
import isEqual from "lodash.isequal";
import { ISearchRequestParamsOmitCountry } from "src/components/pages/search/search.types";

export const useLastKnownRowCount = (searchParams: ISearchRequestParamsOmitCountry | null, rowCount: number): number => {
    const [lastKnownRowCount, setLastKnownRowCount] = useState(rowCount);
    const [lastAppliedSearchParams, setLastAppliedSearchParams] = useState(searchParams);

    if (!isEqual(searchParams, lastAppliedSearchParams)) {
        setLastAppliedSearchParams(searchParams);
        setLastKnownRowCount(rowCount);

        return rowCount;
    }

    if (rowCount > 0 && rowCount !== lastKnownRowCount) {
        setLastKnownRowCount(rowCount);

        return rowCount;
    }

    return lastKnownRowCount;
};
